// removed by extract-text-webpack-plugin
module.exports = {"badge":"src-lib-badge-src-badge__badge--30w5K"};